import { getAdChargeInfoForLx, HIT_AD } from '../common/BaseComponent/adReport';
import {
  HomePageCid, ProductCardMc, ProductCardMv, ProductCardUnfoldButtonMc, ProductCardUnfoldButtonMv
} from './constant';

// 默认为首页cid
let currentCid = HomePageCid;
const Statistics = Mach.requireModule('Statistics');

// 灵犀埋点上报参数处理
export const handleLXParam = (data: any, shop_index: number, pageLogData: any) => {
  const logData = data?.logData || {};
  //广告计费信息
  let adInfo = {};
  if (data?.adInfo?.hitAd === HIT_AD) {
    adInfo = {
      adType: data?.adInfo?.adType || 0,
      adChargeInfo: getAdChargeInfoForLx(data?.adInfo)
    };
  }

  return {
    shop_index,
    ad: Object.keys(adInfo).length > 0 ? adInfo : undefined,
    page_source: currentCid,
    // todo:为了ocean校验埋点的时候先通过。后续需要删除。
    recommended_reason: '-999',
    recommended_type: '-999',
    ...pageLogData,
    ...logData,
  };
};

export const reportProductCardMc = (data: any, shop_index: number, pageLogData: any) => {
  const params = handleLXParam(data, shop_index, pageLogData);
  Statistics.setTag && Statistics.setTag('sailor_c', {
    [currentCid]: {
      ...params,
      bid: ProductCardMc,
    },
  });
  Statistics.click(currentCid, ProductCardMc, params);
};

export const reportProductCardMv = (data: any, shop_index: number, pageLogData: any) => {
  const params = handleLXParam(data, shop_index, pageLogData);
  Statistics.view(currentCid, ProductCardMv, params);
};

export const reportProductCardUnfoldButtonMv = (data: any, shop_index: number, pageLogData: any) => {
  const params = handleLXParam(data, shop_index, pageLogData);
  Statistics.view(currentCid, ProductCardUnfoldButtonMv, params);
};

export const reportProductCardUnfoldButtonMc = (data: any, shop_index: number, pageLogData: any) => {
  const params = handleLXParam(data, shop_index, pageLogData);
  Statistics.click(currentCid, ProductCardUnfoldButtonMc, params);
};

/**
 * 设置cid
 */
export const setCid = ((cid: string) => {
  currentCid = cid || HomePageCid;
});

export const reportBottomContentMC = (params) => {
  Statistics.click(currentCid, 'b_sailor_c_qfln7mk5_mc', params);
};

export const reportBottomContentPV = (params) => {
  Statistics.view(currentCid, 'b_sailor_c_qfln7mk5_mv', params);
};
